<template>
    <UiSimpleRichtext :blok="blok" />
</template>

<script lang="ts" setup>
import type { ISimpleRichtextConfig } from '@nuxt-monorepo/ui/types/components/SimpleRichtext';

defineProps<{ blok: ISimpleRichtextConfig }>();
</script>
